let counter = 0;

/** Generate a unique client-side ID. Used for DnD tracking — never sent to backend. */
export function uniqueId(prefix = 'id'): string {
  counter += 1;
  return `${prefix}_${Date.now()}_${counter}`;
}
